import { render, staticRenderFns } from "./AppointmentsPage.vue?vue&type=template&id=12491dad&lang=pug&"
import script from "./AppointmentsPage.vue?vue&type=script&lang=js&"
export * from "./AppointmentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports